import { Editor as e, Node as t, Path as n, Text as r, Transforms as i } from "slate";
// lib/LocalizedQuotationMarks/lib/consume.ts
var a = {
	sv: [
		"’",
		"’",
		"”",
		"”"
	],
	fi: [
		"’",
		"’",
		"”",
		"”"
	],
	hu: [
		"’",
		"’",
		"„",
		"”"
	],
	pl: [
		"‚",
		"’",
		"„",
		"”"
	],
	no: [
		"‹",
		"›",
		"«",
		"»"
	],
	nb: [
		"‹",
		"›",
		"«",
		"»"
	],
	nn: [
		"‹",
		"›",
		"«",
		"»"
	],
	en: [
		"‘",
		"’",
		"“",
		"”"
	],
	da: [
		"„",
		"“",
		"„",
		"“"
	],
	de: [
		"‚",
		"‘",
		"„",
		"“"
	],
	fr: [
		"‹ ",
		" ›",
		"« ",
		"»"
	]
}, o = { sv: "–" }, s = [
	9,
	32,
	60,
	33,
	40,
	41,
	43,
	44,
	45,
	46,
	47,
	58,
	59,
	60,
	61,
	62,
	63
], c = async ({ editor: t, input: c }) => {
	let { selection: u } = t, d = t.lang.substring(0, 2).toLowerCase();
	if (Array.isArray(c) || typeof c.data != "string" || !u || u.anchor.path.length < 2) return;
	let { data: f } = c;
	if (f[0] === "-" && o[d] && l(t, u)) return {
		...c,
		data: o[d] + f.slice(1)
	};
	if (f[0] === "-") {
		let { anchor: n } = u, a = e.before(t, n, { unit: "character" });
		if (a) {
			let [n] = e.node(t, a.path);
			if (r.isText(n) && n.text[a.offset] === "-") return i.delete(t, { at: a }), {
				...c,
				data: "–"
			};
		}
	}
	let p = n.parent(u.anchor.path), m = u.anchor.path[u.anchor.path.length - 1], h = u.anchor.offset, g, _ = "";
	for (let n = m; n >= 0; n--) {
		let [i, a] = e.node(t, [...p, n]);
		if (r.isText(i)) {
			for (let e = h || i.text.length - 1; e >= 0; e--) {
				if (g) {
					let t = i.text[e];
					if (!isNaN(parseInt(t)) && s.includes(_.charCodeAt(0))) return c;
					n = -1;
					break;
				}
				i.text[e] === f ? g = {
					path: a,
					offset: e
				} : _ = i.text[e];
			}
			h = 0;
		}
	}
	if (!g) return c;
	let v = a[d] || a.en, y = [];
	if (f === "'") y = [v[0], v[1]];
	else if (f === "\"") y = [v[2], v[3]];
	else return c;
	return i.delete(t, { at: g }), i.insertText(t, y[0], { at: g }), {
		...c,
		data: y[1]
	};
};
function l(e, i) {
	let { anchor: a } = i;
	if (a.path.length < 2) return !1;
	let o = n.parent(a.path), s = t.first(e, o);
	if (!s) return !1;
	let [c, l] = s;
	return r.isText(c) ? n.equals(a.path, l) && a.offset === 0 : !1;
}
export { c as consume };
